import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";
import {FaReact,FaNodeJs,FaHtml5} from "react-icons/fa";
import {DiMongodb,DiJavascript,DiCss3} from "react-icons/di"
import {AiFillApi} from "react-icons/ai"
import {SiFirebase,SiCodio,SiCplusplus,SiPython,SiJava,SiMysql,MdLanguage,MdDeveloperMode} from "react-icons/all"
import { Container } from "react-bootstrap";
import { Row,Col } from "react-bootstrap";


class ServiceThree extends Component {
  render() {
    const { column } = this.props;
    // const ServiceContent = ServiceList.slice(0, this.props.item);

    return (
      <React.Fragment>
        <Row>
          <Col style={{display:"flex",justifyContent:"center"}} sm>
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" , width:"400px" }}
            >
              <Container className="icon" style={{display:"flex",justifyContent:"center"}}><MdDeveloperMode/></Container>
              <div className="content">
                <h3 className="title" style={{textAlign:"center"}}>Currentely Working On</h3>
                <p className="skillp">
                <span className="spanedu">React js <FaReact className="skillicon"/></span>
                <span className="spanedu">Node js <FaNodeJs className="skillicon"/></span>
                <span className="spanedu">Express js</span>
                <span className="spanedu">Mongo DB <DiMongodb className="skillicon"/></span>
                <span className="spanedu">Javascript <DiJavascript className="skillicon"/></span>
                <span className="spanedu">Html <FaHtml5 className="skillicon"/></span><br/>
                <span className="spanedu">Css <DiCss3 className="skillicon"/></span>
                <span className="spanedu">API <AiFillApi className="skillicon"/></span><br/>
                <span className="spanedu">Firebase <SiFirebase className="skillicon"/></span>
                </p>
              </div>
            </div>
            {/* </a> */}
          </Col>

          
          <Col style={{display:"flex",justifyContent:"center"}} sm data-aos="zoom-in-up">
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" , width:"400px" }}
            >
              <Container className="icon" style={{display:"flex",justifyContent:"center"}}><MdLanguage/></Container>
              <div className="content">
                <h3 className="title" style={{textAlign:"center"}}>Familiar of</h3>
                <p className="skillp">
                <span className="spanedu">C <SiCodio className="skillicon"/></span>
                <span className="spanedu">Cpp <SiCplusplus className="skillicon"/></span>
                <span className="spanedu">Python <SiPython className="skillicon"/></span><br/>
                <span className="spanedu">Java <SiJava className="skillicon"/></span>
                <span className="spanedu">Mysql/SQL <SiMysql className="skillicon"/></span>
                </p>
              </div>
            </div>
            {/* </a> */}
          </Col>
        
            {/* </a> */}
            </Row>
      
      </React.Fragment>
    );
  }
}
export default ServiceThree;
